export default __webpack_public_path__ + "static/media/Co_2020-1-1.34930e70.png";